import React from "react";

interface IUseFocusResults {
    htmlElementReference: React.RefObject<HTMLInputElement | null>;
    setFocus: { (): void };
}

interface IUseFocus {
    (inputFocusParameters?: { preventScroll: boolean }): IUseFocusResults;
}

const DEFAULT_INPUT_FOCUS_PARAMETERS = { preventScroll: true };

export const useFocus: IUseFocus = (inputFocusParameters = DEFAULT_INPUT_FOCUS_PARAMETERS) => {
    const htmlElementReference = React.useRef<HTMLInputElement>(null);
    const setFocus = () => {
        htmlElementReference.current?.focus(inputFocusParameters);
    };
    return { htmlElementReference, setFocus };
};
